/**
 *@description 验证用户名格式 3-16个字母或数字
 * @param str
 */
export function isValidUsername(str) {
  const reg = /^[a-zA-Z0-9_]{3,16}$/;
  return reg.test(str);
}

/**
 * @description 验证URL地址格式
 * @param str
 * @returns {boolean}
 */
export function isValidUrl(str) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(str);
}

/**
 * @description 判断是否全部小写
 * @param str
 * @returns {boolean}
 */
export function isLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @description 判断是否全部大写
 * @param str
 * @returns {boolean}
 */
export function isUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @description 判断是否全为字母
 * @param str
 * @returns {boolean}
 */
export function isAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @description // 手机验证规则
 * @param str
 * @returns {boolean}
 */
export function isDigital(str) {
  const reg = /^[0-9]{6,}$/;
  return reg.test(str);
}

/**
 * @description 判断是否为正整数和浮点数
 * @param str
 * @returns {boolean}
 */
export function isFloating(str) {
  const reg = /^[0-9]+.?[0-9]*$/;
  return reg.test(str);
}

/**
 * @description 不能包含中文和特殊字符
 * @param str
 * @returns {boolean}
 */
export function isSpecial(str) {
  const reg = /^[A-Za-z0-9]+$/;
  return reg.test(str);
}

// /**
//  * @description 正负数、正负浮点数
//  * @param str
//  * @returns {boolean}
//  */
// export function isPositive(str) {
//   const reg = /(^[\-0-9][0-9]*(.[0-9]+)?)$/
//   return reg.test(str)
// }

/**
 * @description 判断是否有中文（也包含日文和韩文）
 * @param str
 * @returns {boolean}
 */
export function isCharacter(str) {
  const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
  return reg.test(str);
}

/**
 * @description 判断是否为电话号码
 * @param str
 * @returns {boolean}
 */
export function isPhoneNumber(str) {
  const reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
  return reg.test(str);
}
/*
  判断是否是 固定电话
  @returns {boolean}
*/
export function isTelephoneNumber(str) {
  const reg = /^(0?(13[0-9]|15[012356789]|166|17[013678]|18[0-9]|14[57])[0-9]{8})|(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})(-| )?)?([0-9]{7,8})((-| |转)*([0-9]{1,4}))?$/;
  return reg.test(str);
}

export function validPhone(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入手机号码'));
  } else {
    if (!/^0?1[3|4|5|6|7|8][0-9]\d{8}$/.test(value)) {
      callback(new Error('请输入正确的手机号码'));
    }
    callback();
  }
}
/**
 * @description 判断是否为泰国手机号
 * @param str
 * @returns {boolean}
 */
export function isTHPhone(str) {
  const reg = /^(0|66)[0-9]{9}$/;
  return reg.test(str);
}
/**
 * @description 判断是否为互联网号码
 * @param str
 * @returns {boolean}
 */
export function isInternet(str) {
  const reg = /^(88)[0-9]{8}$/;
  return reg.test(str);
}
/**
 * @description 判断邮箱是否正确
 * @param str
 * @returns {boolean}
 */
export function isEmail(str) {
  // const reg = /^[a-z0-9A-Z]+([._\\-]*[a-z0-9A-Z])*@([a-z0-9A-Z]+[-a-z0-9A-Z]*[a-z0-9A-Z]+.){1,63}[a-z0-9A-Z]+$/;
  const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return reg.test(str);
}
